<template>
  <div style="margin-top: 20px">
    <div class="infoAiGenerate"
         v-if="talentData.infoAiGenerate"
    >提示：文字内容由AI大模型生成，请仔细甄别</div>

    <div class="text-left bottom-title">
      <div class="messageTitle">基本信息：</div>
      <!--  联系电话,邮箱  -->
      <div class="infoLine">
        <div class="width-25">
          <div class="flex justify-between">
            <div>姓</div>
            <div style="text-align: right">名：</div>
          </div>
          {{ talentData.scholarVO?.scholarName }}
        </div>

        <div class="width-25" v-if="talentData.scholarVO?.scholarOrg">
          <div class="flex justify-between">
            <div>所在机构：</div>
          </div>
          {{ talentData.scholarVO?.scholarOrg }}
        </div>
      </div>

      <div class="infoLine" >
        <div class="width-25" v-if="talentData.scholarVO?.country">
          <div class="flex justify-between">
            <div>国</div>
            <div style="text-align: right">籍：</div>
          </div>
          {{ talentData.scholarVO?.country || '-' }}
        </div>
        <!--  邮箱  -->
        <div class="width-25" v-if="talentData.scholarVO?.estimatedAge">
          <div class="flex justify-between">
            <div style="width: 84px">预估年龄段：</div>
          </div>
          {{ talentData.scholarVO?.estimatedAge || '-' }}
        </div>
      </div>

      <div class="infoLine">
        <div class="width-25" v-if="talentData.scholarVO?.phone">
          <div>联系电话：</div>
          {{ talentData.scholarVO?.phone || '-' }}
        </div>
        <!--  邮箱  -->
        <div class="width-25" v-if="talentData.scholarVO?.email">
          <div class="flex justify-between">
            <div>邮</div>
            <div style="text-align: right">箱：</div>
          </div>
          {{ talentData.scholarVO?.email || '-' }}
        </div>
      </div>
    </div>
    <div class="text-left bottom-title"
         v-if="talentData.info">
      <div class="messageTitle">简介：</div>
      <div style="line-height: 1.6; white-space: pre-wrap">
        {{ talentData.info }}
      </div>
    </div>
    <div class="text-left bottom-title"
         v-if="talentData.eduExperience">
      <div class="messageTitle">教育经历：</div>
      <div
        v-html="talentData.eduExperience"
        style="line-height: 1.6"
      ></div>
    </div>
    <div class="text-left bottom-title"
         v-if="talentData.wordExperience">
      <div class="messageTitle">工作经历：</div>
      <div
        v-html="talentData.wordExperience"
        style="line-height: 1.6"
      ></div>
    </div>
    <div class="text-left bottom-title"
         v-if="talentData.awards">
      <div class="messageTitle">获奖情况：</div>
      <div style="line-height: 1.5">{{ talentData.awards}}</div>
    </div>
    <div class="text-left bottom-title"
         v-if="talentData.socialWork">
      <div class="messageTitle">社会兼职：</div>
      <div style="line-height: 1.5">{{ talentData.socialWork }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'talentInfoDialog',
  props: ['talentData'],
  data() {
    return {
      data: {},
      talentInfoDialog: false,
    };
  },
  methods: {
    showDialog() {
      this.talentInfoDialog = true;
    },
  },
};
</script>

<style scoped lang="less">
.messageTitle {
  margin-bottom: 14px;
  font-size: 16px;
  color: #333333;
}

.bottom-title {
  margin-bottom: 25px;

  div {
    overflow-wrap: anywhere;
  }
}

.infoLine {
  display: flex;
  margin-top: 10px;
  font-size: 14px;
  color: #333333;

  .width-25 {
    display: flex;
    width: 35%;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  div {
    width: 70px;
    color: #999999;
  }

  .info-url {
    color: #333333;
    cursor: pointer;
    text-decoration: underline;
  }
}

.school-bg {
  margin-bottom: 10px;
}


.infoAiGenerate {
  width: 290px;
  text-align: center;
  margin: 20px 0;
  background-color: #e9ebf5ad;
  padding: 8px 0;
  //color: #1241C9;
  font-size: 13px;
  color: rgba(0,0,0,0.45);
}
</style>
